import { combineReducers } from 'redux';

// Account / Profile
import profileReducer from './profile';
import accountReducer from './account';

// Personas
import agentReducer from './agent';

// Customer
import segmentsReducer from './segments';
import insightsReducer from './insights';

// Knowledge
// import domainsReducer from './domains';
import researchReducer from './research';

// ...
import knowledgeReducer from './knowledge';
import reportReducer from './report';
import modelReducer from './model';

// Theme / Branding
import themeReducer from './theme';

// ===========================|| COMBINE REDUCER ||=========================== //

const reducer = combineReducers({
  profile: profileReducer,
  account: accountReducer,

  segments: segmentsReducer,
  insights: insightsReducer,

  // domains: domainsReducer,
  research: researchReducer,
  agent: agentReducer,

  knowledge: knowledgeReducer,
  model: modelReducer,
  report: reportReducer,

  theme: themeReducer
});

export default reducer;
